import { Builder } from '@builder.io/react'
import React, { useEffect, useState } from 'react'

import DesktopSteps from './desktop-steps'
import MobileSteps from './mobile-steps'
import { StepItemProps, StepItemRegisterProps } from './step-items'

// import './index.css'

interface Props {
  backgroundColor: string
  stepItems: StepItemProps[]
}

const NumberedSteps = ({ backgroundColor, stepItems }: Props) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleWindowSizeChange = () => {
    if (window.innerWidth <= 640) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  useEffect(() => {
    handleWindowSizeChange()
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const renderComps = () => {
    if (isMobile) {
      return (
        <div className="relative mx-5  sm:hidden" id="steps-section-mobileView">
          <MobileSteps Items={stepItems.slice(0, 5)} />
        </div>
      )
    }

    return (
      <div className="relative left-[5%] hidden  pt-10 pb-20 sm:flex sm:flex-col" id="steps-section-desktopView">
        <DesktopSteps Items={stepItems.slice(0, 5)} />
      </div>
    )
  }

  return (
    <div className="steps-mega-parent w-full overflow-hidden" style={{ backgroundColor }}>
      {renderComps()}
    </div>
  )
}

export default NumberedSteps

Builder.registerComponent(NumberedSteps, {
  name: 'NumberedSteps',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'stepItems',
      type: 'list',
      defaultValue: [{ ...StepItemRegisterProps.defaultValue }],
      subFields: StepItemRegisterProps.subFields
    }
  ]
})
